import React from "react";
import "./Footer.css";
import { useLocalContext } from "../../context/LocalContext";

const Footer = () => {
  const { webinfo } = useLocalContext();

  return (
    <footer className="footer modern-footer">
    
  <div className="footer-disclaimer">
  <strong>Disclaimer:</strong> All travel bookings and offers are subject to availability and may change without notice. {webinfo.name} is not liable for unforeseen schedule changes, delays, or third-party service issues. Please review all terms and conditions before confirming your reservation, and consider appropriate travel insurance for added peace of mind.
</div>



      <div className="footer-container">
        {/* Column 1: Brand */}
        <div className="footer-brand">
          <h2>{webinfo.name}</h2>
          <p>
            Your trusted companion for seamless, unforgettable adventures. We
            help you explore the world, connect with cultures, and create
            stories that last a lifetime.
          </p>
        </div>

        {/* Column 2: Quick Links */}
        <div className="footer-links">
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/flight">Flight Deals</a></li>
            <li><a href="/packages">Packages</a></li>
            <li><a href="/carrentals">Car Rentals</a></li>
            <li><a href="/hotels">Hotel Stays</a></li>
          </ul>
        </div>

        {/* Column 3: Company */}
        <div className="footer-links">
          <h4>Company</h4>
          <ul>
            <li><a href="/about">About Us</a></li>
            <li><a href="/contact">Get in Touch</a></li>
            <li><a href="/disclaimer">Disclaimer</a></li>
             <li><a href="/privacy-policy">Privacy Policy</a></li>
            <li><a href="/terms-and-condition">Terms & Conditions</a></li>
             <li><a href="/cancellation-policy">Cancellation Policy</a></li>
          </ul>
        </div>

        {/* Column 4: Get in Touch */}
        <div className="footer-contact">
          <h4>Reach Us</h4>
          <p><strong>Email:</strong> {webinfo.email || "contact@adventureworld.com"}</p>
          <p><strong>Office:</strong> {webinfo.address || "Globally Remote Team"}</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>
          &copy; {new Date().getFullYear()} {webinfo.name || "AdventureWorld"}. All rights reserved.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
